import("../../../../Social-Sorbet/assets/js/splide.js")
	.then(({ Splide }) => {
		const sliders = document.querySelectorAll(".related-events-slider .splide")

		for (let i = 0; i < sliders.length; i++) {
			const trackEl = sliders[i].querySelector(".splide__track")
			const trackId = "splide-track-" + i
			if (trackEl) trackEl.setAttribute("id", trackId)

			const splide = new Splide(sliders[i], {
				type: "slide",
				arrows: false,
				pagination: false,
				padding: "0rem",
				gap: "1.5rem",
				perPage: 2,
				breakpoints: {
					767: {
						perPage: 1,
					},
				}
			}).mount()

			const container = sliders[i].closest(".sorbet-align-container")
			const prevBtn = container && container.querySelector(".splide__arrow--prev")
			const nextBtn = container && container.querySelector(".splide__arrow--next")

			if (prevBtn) {
				prevBtn.setAttribute("aria-controls", trackId)
				prevBtn.addEventListener("click", () => splide.go("<"))
			}
			if (nextBtn) {
				nextBtn.setAttribute("aria-controls", trackId)
				nextBtn.addEventListener("click", () => splide.go(">"))
			}

			function updateArrowStates() {
				if (!prevBtn || !nextBtn) return
				const end = splide.Components.Controller.getEnd()
				prevBtn.setAttribute("aria-disabled", splide.index === 0 ? "true" : "false")
				nextBtn.setAttribute("aria-disabled", splide.index >= end ? "true" : "false")
			}

			updateArrowStates()
			splide.on("moved", updateArrowStates)
		}
	})
	.catch((err) => {
		console.error(err)
	});
